<template>
     <v-dialog persistent v-model="dialog" width="50%">
        <v-card fluid>
            <v-card-title>
                Mapping {{ map.unit }} ({{ map.productname }})
            </v-card-title>
            <v-divider  class="ml-2 mr-2 mb-2"></v-divider>
            <div class="grid ml-6 mb-1" style="font-size: medium !important;">
                <div>Code</div>
                <div>{{ map.qennercode }} - {{ map.description }}</div>
                <div>Amount</div>
                <div>{{ map.price }} ({{ map.priceunit }})</div>
                <div>Mandatory</div>
                <div v-if="map.mandatory"><v-icon color="warning" size="24">mdi-alert-circle</v-icon>
                </div>
                <div v-else><v-icon size="24">mdi-cancel</v-icon></div>
            </div>
            <div v-if="hasConfig">
                <v-divider  class="ml-2 mr-2 mt-2"></v-divider>
                <div class="ml-6 py-2 flex grid" style="font-weight: 600 !important;">
                    Current mapping
                    <div v-if="map.combination" style="color: red">Combination with Ares code {{ map.restrictedcode }}</div>
                </div>
                <div class="grid ml-6 mb-1">
                    <div>Code</div>
                    <div>{{ map.arescode }} - {{ map.aresdescription }}</div>
                    <div>Amount</div>
                    <div>{{ map.aresprice }} ({{ map.arespriceunit }})</div>
                    <div>Check amount</div>
                    <div v-if="map.checkamount"><v-icon color="success" size="24">mdi-check-bold</v-icon></div>
                    <div v-else><v-icon  size="24">mdi-cancel</v-icon></div>
                    <div>Actively checked</div>
                    <div v-if="map.active"><v-icon color="success" size="24">mdi-check-bold</v-icon></div>
                    <div v-else><v-icon  size="24">mdi-cancel</v-icon></div>                        
                </div>
            </div>
            <v-divider  class="ml-2 mr-2 mt-2"></v-divider>
            <div v-if="hasConfig">
                <div class="ml-6 py-2" style="font-weight: 600 !important;">Modify mapping</div>
            </div>
            <div v-else>
                <div class="ml-6 py-2" style="font-weight: 600 !important;">Add mapping</div>
            </div>      
            <div class="ml-6">
                <v-checkbox hide-details dense color="blue" label="Active" v-model="active" class="my-0 py-0"></v-checkbox>
                <v-checkbox hide-details dense color="blue" label="Check amount" v-model="checkamount" class="my-0 py-0"></v-checkbox>
                <div class="gridx gridxheader mt-2">
                    <div class="gridxcol">Sel.</div>
                    <div class="gridxcol">Code</div>
                    <div class="gridxcol">Description</div>
                    <div class="gridxcol">Payment</div>
                    <div class="gridxcol number">Purchase</div>
                    <div class="gridxcol number">Sales</div>
                    <div class="gridxcol">Unit</div>
                </div>
                <ul class="mb-6">
                    <li v-for="(kstp, idx) in this.hpbk" :key="idx" class="gridx">         
                        <div class="gridxcol"><v-simple-checkbox dense v-model="kstp.selected" @click="check(idx)"></v-simple-checkbox></div>
                        <div class="gridxcol">{{ kstp.arescode }}</div>
                        <div class="gridxcol">{{ kstp.aresdescription }}</div>
                        <div class="gridxcol">{{ kstp.payment }}</div>
                        <div class="gridxcol number">{{ kstp.purchase }}</div>
                        <div class="gridxcol number">{{ kstp.sales }}</div>
                        <div class="gridxcol">{{ kstp.unit }}</div>
                    </li>
                </ul>                
            </div>      
                        
            <v-card-actions>
                <v-spacer></v-spacer>              
                <v-btn @click="closeDialog()" color="primary">
                    cancel
                </v-btn>                  
                <v-btn @click="use(map)" color="success">
                    use
                </v-btn>
            </v-card-actions>
        </v-card>            
        <stddlg ref="std_dialog" />
    </v-dialog>
</template>

<script>
import stddlg from '@/components/ui/standard_dialog.vue'
export default {
    components: {
        stddlg
    },        
    data() {
        return {
            map: {},
            hpbk: [],
            selHpbk: [],
            checkamount: false,
            active: false,
            hasConfig: false,
            dialog: false,
        }
    },    
    methods: {
        open(map, hpbk) {
            this.map = map;
            this.hpbk = hpbk;
            this.dialog = true;
            this.hasConfig = false
            this.checkamount = map.checkamount
            this.active = map.active
            this.selHpbk = []
            
            this.hpbk.forEach(el => {
                el.selected = false
                if(el.arescode === map.arescode) { 
                    el.selected = true
                    this.hasConfig = true
                }    
            })
        },                    
        closeDialog() {
            this.dialog = false;
        },
        show_message(v){
            this.$refs.std_dialog.open('error', "Error", v);   
        },
        use(map){
            let t = 0;
            this.hpbk.forEach(el => {
                if(el.selected) { 
                    this.selHpbk.push(el)
                    t++
                }                    
            })
            if(t > 2){
                this.show_message("You cannot combine more than two (2) ares cost codes to one external cost code. This action is not supported")
                return
            }
            map['sel_hpbk'] = this.selHpbk
            map['sel_active'] = this.active
            map['sel_checkamount'] = this.checkamount
            this.$emit('use', map)
            this.closeDialog()
        }, 
        check(idx) {
            if(this.hasConfig) {
                this.hpbk.forEach((el, i) => {
                    if(i !== idx){
                        el.selected=false
                    } else {
                        this.map.arescode = el.arescode
                        this.map.aresdescription = el.aresdescription
                    }
                })
            }
        }

    }
}

</script>

<style scoped>
.flex{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.grid{
    display: grid; 
    column-count: 2; 
    grid-template-columns: 1fr 2fr; 
}
.gridx{
    display: grid; 
    column-count: 7; 
    grid-template-columns: 0.5fr 0.75fr 1.5fr 0.8fr 0.8fr 0.8fr 1fr; 
    padding-right: 20px;
}
.gridxheader{
    font-weight: 600;
}
.gridxcol{    
    padding-top: 2px;
    padding-bottom: 2px;
    border-bottom: 1px solid;
    border-color: lightgray;
}
ul{
    list-style-type: none;
    /* white-space:nowrap; */
    padding: 0;
    margin: 0;
}    
.number {
    display: flex;
    flex-direction: row; 
    justify-content: flex-end;
    padding-right: 20px !important;
}

</style>